export default {
  SET_DONORS(state, donors) {
    state.donorsState = 'ready'
    state.donors = donors
    state.lastUpdate = parseInt((new Date().getTime() / 1000));
  },
  RESET_DONORS(state) {
    state.donorsState = null
    state.donors = []
  },
  LOADING_DONORS(state) {
    state.donorsState = 'loading'
  },
  SET_CONTACT_STATS(state, contactStats) {
    state.contactStatsState = 'loading';
    state.contactStats = JSON.parse(JSON.stringify(contactStats));
    state.contactStatsState = 'ready';
  },
  SET_CONTACT_STATS_STATE(state, status) {
    state.contactStatsState = status;
  },
  SET_GENDERS(state, genders) {
    state.genders = genders
    state.gendersLastUpdate = parseInt((new Date().getTime() / 1000));
  },
}
